import { FC, HTMLAttributes, useCallback } from 'react';
import DropDownButtonLegacy from '../drop-downs/legacy/dropDownButtonLegacy';
import { DropDownItemType } from '../drop-downs/legacy/dropDownItemType';
import SimpleButtonContainerContent from '../drop-downs/legacy/simpleDropDownButtonContainerContent';

export interface ActionItems extends DropDownItemType {
  label: string;
  key: string;
  isActive: boolean;
  onAction: () => any;
  isLoading?: boolean;
}

const ActionsButton: FC<
  {
    label: string;
    actions: ActionItems[];
  } & HTMLAttributes<HTMLAnchorElement>
> = ({
  label,
  actions,
  ...rest
}: {
  label: string;
  actions: ActionItems[];
}) => {
  const anyLoadingAction = useCallback(() => {
    return actions.some((action) => action.isLoading);
  }, [actions]);

  return (
    <>
      <DropDownButtonLegacy
        dropDownItems={actions}
        selectDropDownItem={(key: string): void =>
          actions.find((action) => action.key === key)?.onAction()
        }
        {...rest}
      >
        <SimpleButtonContainerContent
          dropdownLabel={label}
          additionalContainerStyling="bg-white rounded border border-neutral-200 items-center"
          isLoading={anyLoadingAction()}
        />
      </DropDownButtonLegacy>
    </>
  );
};

export default ActionsButton;
